<template>
  <IconWave
      ref="wave"
      v-if="props.waveType === 'wave' && !props.waveNegative && !props.waveMirrored"
      :mask-id="maskId"
      class="app-wave wave"
  />
  <IconWaveFlip
      ref="wave"
      v-else-if="props.waveType === 'wave' && !props.waveNegative && props.waveMirrored"
      :mask-id="maskId"
      class="app-wave wave-flip"
  />
  <IconWaveNegativ
      ref="wave"
      v-else-if="props.waveType === 'wave' && props.waveNegative && !props.waveMirrored"
      :mask-id="maskId"
      class="app-wave wave-negativ"
  />
  <IconWaveNegativFlip
      ref="wave"
      v-else-if="props.waveType === 'wave' && props.waveNegative && props.waveMirrored"
      :mask-id="maskId"
      class="app-wave wave-negativ-flip"
  />
  <IconWaveDouble
      ref="wave"
      v-else-if="props.waveType === 'double-wave' && !props.waveNegative && !props.waveMirrored"
      :mask-id="maskId"
      class="app-wave double-wave"
  />
  <IconWaveDoubleFlip
      ref="wave"
      v-else-if="props.waveType === 'double-wave' && !props.waveNegative && props.waveMirrored"
      :mask-id="maskId"
      class="app-wave double-wave-flip"
  />
  <IconWaveDoubleNegativ
      ref="wave"
      v-else-if="props.waveType === 'double-wave' && props.waveNegative && !props.waveMirrored"
      :mask-id="maskId"
      class="app-wave double-wave-negativ"
  />
  <IconWaveDoubleNegativFlip
      ref="wave"
      v-else
      :mask-id="maskId"
      class="app-wave double-wave-negativ-flip"
  />
</template>

<script lang="ts" setup>

import { Ref, ref } from 'vue';
import IconWave from '@/components/icons/IconWave.vue';
import IconWaveFlip from '@/components/icons/IconWaveFlip.vue';
import IconWaveNegativ from '@/components/icons/IconWaveNegativ.vue';
import IconWaveNegativFlip from '@/components/icons/IconWaveNegativFlip.vue';
import IconWaveDouble from '@/components/icons/IconWaveDouble.vue';
import IconWaveDoubleFlip from '@/components/icons/IconWaveDoubleFlip.vue';
import IconWaveDoubleNegativ from '@/components/icons/IconWaveDoubleNegativ.vue';
import IconWaveDoubleNegativFlip from '@/components/icons/IconWaveDoubleNegativFlip.vue';

const props = defineProps({
  waveType: {
    type: String,
    required: false,
    default: () => 'none',
  },
  background: {
    type: String,
    required: false,
    default: () => 'white',
  },
  waveMirrored: {
    type: Boolean,
    default: false,
  },
  waveNegative: {
    type: Boolean,
    default: false,
  },
  maskId: String,
});

const wave = ref();

defineExpose<{
  rootEl: Ref<HTMLElement>,
}>({
  rootEl: wave,
});
</script>
